/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useContext, useMemo} from 'react'

import Context from '@s-ui/react-context'

import {hpToKw} from '../utils.js'

const useLabel = ({categoryId}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {kwFromHp} = config.get('search')
  const {CATEGORIES_WITH_ELECTRIC_FEATURES} = config.get('searchFilters')

  const hasElectricFeatures = useMemo(() => CATEGORIES_WITH_ELECTRIC_FEATURES.includes(categoryId), [categoryId])

  const getLabel = useCallback(
    ({value}) =>
      hasElectricFeatures
        ? `${i18n.n(value)} ${i18n.t('COMMON.UNIT_HP')} (${i18n.n(kwFromHp[value] || hpToKw(value))} ${i18n.t(
            'COMMON.UNIT_KW'
          )})`
        : `${i18n.n(value)} ${i18n.t('COMMON.UNIT_HP')}`,
    [hasElectricFeatures, kwFromHp]
  )

  return {labelFormatter: getLabel}
}

export default useLabel
